export default "__VITE_PUBLIC_ASSET__37a68bf1__"